import { render, staticRenderFns } from "./IntentComponent.vue?vue&type=template&id=a88a9c88&scoped=true"
import script from "./IntentComponent.vue?vue&type=script&lang=js"
export * from "./IntentComponent.vue?vue&type=script&lang=js"
import style0 from "./IntentComponent.vue?vue&type=style&index=0&id=a88a9c88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88a9c88",
  null
  
)

export default component.exports